<template>
  <transition name="router-anim">
    <div class="kits">
      <div class="top-panel">
        <DescriptionModal class="description-modal" 
          :description="`This page displays the testkits that have taken longer than the expected timeframe to move through their processing stages.`" />
        <div class="prob-count custom" v-if="steps.value && overduestyle">
          <span :class="overduestyle+'-color'">{{ steps.value.charAt(0).toUpperCase() + steps.value.slice(1) }} Outliers: {{kits.length}} of {{ report.total }}</span>
        </div>
        <div class="prob-count custom" v-else>
          Total: {{ total }}
        </div>
      </div>  
      <div>
        <div v-if="showstatuscolumn" class="kits-title">
          <div class="title id">
            KIT ID
          </div>
          <div class="title status">
            STATUS
          </div>
          <div class="title first-name">
            FIRST NAME
          </div>
          <div class="title last-name">
            LAST NAME
          </div>
          <div class="title email">
            EMAIL
          </div>
          <div class="title phone">
            PHONE
          </div>
          <div class="title date" @click="sortedBy">
            SHIP DATE
            <img
              src="../../images/dashboard/up.png"
              alt="#"
              v-if="sortedByState === 'desc'"
            />
            <img
              class="down"
              src="../../images/dashboard/up.png"
              alt="#"
              v-else
            />
          </div>
        </div>

        <div v-else class="kits-title">
          <div class="title id">
            ORDER ID
          </div>
          <div class="title first-name">
            FIRST NAME
          </div>
          <div class="title last-name">
            LAST NAME
          </div>
          <div class="title email">
            EMAIL
          </div>
          <div class="title phone">
            PHONE
          </div>
          <div class="title date" @click="sortedByOverdue" style="width: 15%;">
            SHIP DATE
            <img
              src="../../images/dashboard/up.png"
              alt="#"
              v-if="sortedByState === 'desc'"
            />
            <img
              class="down"
              src="../../images/dashboard/up.png"
              alt="#"
              v-else
            />
          </div>
        </div>
      </div>
      <div v-if="kit_split.length > 0" >
        <div v-for="item in kit_split" :key="item.id">
          <div v-if="item.type==='overduelist'" class="kits-item">
              <div
                class="kit-desc id"
                @click.stop="stopPropagation"
              >
                <a :href="`${wordpress_order_page_url+item.id+'&action=edit'}`" target="_blank" class="left-space">
                  <span class="link-text">{{ item.id }}</span>
                </a>
              </div>
              <div class="kit-desc first-name">
                <span>{{ item.first_name }}</span>
              </div>
              <div class="kit-desc last-name">
                <span>{{ item.last_name }}</span>
              </div>
              <div class="kit-desc email" v-if="item.user_email">
                <span>{{ item.user_email }}</span>
              </div>
              <div class="kit-desc phone">
                <span>{{ makePhone(item.phone) }}</span>
              </div>
              <div class="kit-desc date_list">
                {{ date(item.date_created) }}
              </div>
          </div>

          <div class="kits-item" v-else>
              <div
                class="kit-desc id"
                @click.stop="stopPropagation"
                @click="showModal(item.id, item.user_id, 'kit')"
              >
                {{ convertKitId(item.kit_id) }}
              </div>
              <div
                class="kit-desc status"
                :style="
                  item.status === 'on_hold' ? { color: 'rgb(232, 122, 1)' } : null
                "
              >
                <span class="onHoldStatus" v-if="item.status === 'on_hold'">
                  On Hold
                  <button
                    @click.stop="stopPropagation"
                    @click="showModal(item.id, item.user_id, 'hold')"
                    class="onhold-btn"
                  >
                    <img
                      class="onhold-btn-img"
                      src="../../images/dashboard/onhold.png"
                      alt="#"
                    />
                  </button>
                </span>
                <span v-if="item.status === 'analysis_completed'"
                  >Analysis Complete</span
                >
                <span v-if="item.status === 'analysis_failed'">Analysis Failed</span>
                <span v-if="item.status === 'lab_received'">Lab Received</span>
                <span v-if="item.status === 'lab_awaiting'">Submitted</span>
                <span v-if="item.status === 'shipped'">Shipped</span>
                <span v-if="item.status === 'delivered'">Delivered</span>
                <span v-if="item.status === 'activated'">Activated</span>
                <div
                  class="status-line"
                  :style="
                    item.status === 'on_hold'
                      ? { backgroundColor: 'rgba(232, 122, 1, .4)' }
                      : null
                  "
                >
                  <div
                    class="status-line-bg"
                    :style="[
                      item.status === 'shipped' ? { width: '16.6%' } : null,
                      item.status === 'delivered' ? { width: '28.8%' } : null,
                      item.status === 'activated' ? { width: '49.8%' } : null,
                      item.status === 'lab_awaiting' ? { width: '66.4%' } : null,
                      item.status === 'lab_received' ? { width: '83%' } : null,
                      item.status === 'on_hold'
                        ? { width: '83%', backgroundColor: '#E87A01' }
                        : null,
                      item.status === 'analysis_failed'
                        ? { width: '100%', backgroundColor: 'red' }
                        : null,
                      item.status === 'analysis_completed' ? { width: '100%' } : null
                    ]"
                  ></div>
                </div>
              </div>
              <div class="kit-desc first-name">
                <span>{{ item.collected_first_name }}</span>
              </div>
              <div class="kit-desc last-name">
                <span>{{ item.collected_last_name }}</span>
              </div>
              <div class="kit-desc email" v-if="item.collected_email">
                <span>{{ item.collected_email }}</span>
              </div>
              <div class="kit-desc email" v-else>
                <span v-if="item.user">{{ item.user.email }}</span>
              </div>
              <div class="kit-desc phone">
                <span v-if="item.user">{{ makePhone(item.user.phone) }}</span>
              </div>
              <div class="kit-desc date">
                {{ date(item.shipped_at) }}
              </div>
              <div
                title="Archive"
                class="archive-kit-btn"
                v-if="role === 'superadmin' && item.status !== 'archive'"
                @click="archive(item)"
              >
                <img
                    src="../../images/dashboard/archive-black.png"
                    alt="#"
                  />
              </div>
              <div
                title="Delete"
                class="remove-kit-btn"
                v-if="role === 'superadmin'"
                @click="remove(item)"
              ></div>
          </div>
        </div>
      </div>
      <div v-else class="kits-item">
        <div class="kit-desc nodata">
          No Data Retrieved.
        </div>
      </div>
      <div class="pogination">
        <Paginate
          v-if="count_page > 1"
          :page-count="count_page"
          :page-class="'pogination-item'"
          :click-handler="changePage"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'pogination-wrap'"
        ></Paginate>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import Paginate from "vuejs-paginate";
import moment from "moment";
import { parseAndConvertKitId } from "../mixins/parseAndConvertKitId";
import Remove from "../../images/dashboard/Remove";

export default {
  name: "PendingKits",
  props: ['steps'],
  mixins: [parseAndConvertKitId],
  data() {
    return {
      kits: [],
      count_page: 1,
      sortedByState: "desc",
      kit_split:[],
      offset:0,
      limit:10,
      showstatuscolumn: true,
      wordpress_order_page_url: process.env.VUE_APP_WORDPRESS_ORDER_PAGE_LINK,
      overduestyle:null,
      total:0,
      report: {
        total: 0
      },
    };
  },
  components: {
    Paginate,
    Remove
  },
  methods: {
    changePage(item) {
      this.offset = (item-1) * 10;
      this.limit = this.offset + 10;
      this.kit_split = this.kits.slice(this.offset,this.limit);
    },
    ...mapActions([
      "testKitInfo",
      "getUserInfo",
      "sendSearchReq",
      "setSortedBy",
      "setPginationPage",
      "sendSearchReqPending",
      "setOverDueByShipped"
    ]),
    remove(item) {
      this.$emit("confurmDelKit", { show: true, id:item.id, kit_id:this.convertKitId(item.kit_id)});
    },
    archive(item) {
      this.$emit("confurmArvKit", { show: true, id: item.id, title: item.title, kit_id:item.kit_id});
    },
    sortedBy() {
      if (this.sortedByState === "desc") {
        this.sortedByState = "asc";
      } else {
        this.sortedByState = "desc";
      }
      this.setSortedBy(this.sortedByState);
      if (this.steps.steps!='' && this.steps.steps == "4")
      {
        this.sendSearchReqPending();
      } else {
        this.sendSearchReqPending();
      }
    },
    sortedByOverdue() {
      if (this.sortedByState === "desc") {
        this.sortedByState = "asc&overdue=overduelist";
      } else {
        this.sortedByState = "desc&overdue=overduelist";
      }
      this.setSortedBy(this.sortedByState);
      if (this.steps.steps!='' && this.steps.steps == "4")
      {
        this.sendSearchReqPending();
      } else {
        this.sendSearchReqPending();
      }
    },
    makePhone(phone) {
      // Check if phone is null or undefined
      if (phone === null || phone === undefined) {
        return null;
      }

       // Remove any non-digit characters from the input
       const cleanPhone = phone.replace(/\D/g, '');

      // Check if the cleaned phone number is exactly 10 digits
      if (cleanPhone.length === 11 || cleanPhone.length === 10) {
        const phoneArr = cleanPhone.split("");
        let  convertedPhone = null;
        if (cleanPhone.length === 11){
        convertedPhone = `(${phoneArr[1]}${phoneArr[2]}${phoneArr[3]}) ${phoneArr[4]}${phoneArr[5]}${phoneArr[6]}-${phoneArr[7]}${phoneArr[8]}${phoneArr[9]}${phoneArr[10]}`;
        } else if (cleanPhone.length === 10) {
        convertedPhone = `(${phoneArr[0]}${phoneArr[1]}${phoneArr[2]}) ${phoneArr[3]}${phoneArr[4]}${phoneArr[5]}-${phoneArr[6]}${phoneArr[7]}${phoneArr[8]}${phoneArr[9]}`;
        }
        return convertedPhone;
      } else {
        return null;
      }
    },
    showModal(kitId, userId, modal) {
      this.testKitInfo(kitId).then(res => {
        if (modal === "kit") {
          if (userId !== null) {
            this.getUserInfo(userId).then(res => {
              this.$emit("showModal", true);
            });
          } else {
            this.$emit("showModal", true);
          }
        } else if (modal === "hold") {
          this.$emit("showComment", {
            txt: this.$store.getters.getTestKitInfo.reason_on_hold,
            show: true,
            id: this.$store.getters.getTestKitInfo.id
          });
        }  else if (modal === "archive") {
          this.$emit("showCommentArchive", {
            txt: this.$store.getters.getTestKitInfo.reason_archive,
            show: true,
            id: this.$store.getters.getTestKitInfo.id
          });
        }
      });
    },
    date(localDate) {
      if (localDate !== null) {
        let date = new Date(localDate);
        return moment(date).format("MM/DD/YYYY");
      }
    },
    stopPropagation(event) {
      event.stopPropagation();
    }
  },
  computed: {
    ...mapGetters(["getPendingKits", "pogination", "role",'getOverDueStyle','adminReport'])
  },
  watch: {
    getPendingKits(obj) {
      this.kits = obj;
      this.total = obj.length;
      this.kit_split = obj.slice(this.offset,this.limit);
      this.offset = 0;
      this.limit = 10;
      this.kit_split.forEach((item, index) => {
        const type = item.type;
        if(type == 'overduelist') {
          this.showstatuscolumn = false;
        }else {
          this.showstatuscolumn = true;
        }
      });
    },
    pogination(num) {
      this.count_page = num;
    },
    getOverDueStyle(val){
      this.overduestyle = val;
    },
    adminReport(obj) {
      if (!obj) return; // ← ADD THIS
      this.report.total = Number(obj.total);
    }
  },
  mounted() {
    if(this.$store.getters.adminReport != null) {
      this.report.total = Number(this.$store.getters.adminReport.total);
    }
    if (this.$store.getters.getPendingKits) {
      this.kits = this.$store.getters.getPendingKits;
      this.total = this.$store.getters.getPendingKits.length;
      this.kit_split = this.$store.getters.getPendingKits.slice(this.offset,this.limit);
    }
    if (this.$store.getters.pogination !== null) {
      this.count_page = this.$store.getters.pogination;
    }
    if (this.$store.getters.getOverDueStyle) {
      this.overduestyle = this.$store.getters.getOverDueStyle;
    }
    // this.sendSearchReq();
  }
};
</script>

<style scoped lang="scss">
.kits {
  margin: 15px 0 0 0;
}
.kits-title {
  display: flex;
  justify-content: space-between;
  margin: 0 0 20px 0;
  padding: 0 30px;
}
.title {
  color: #b3b3b3;
  font-size: 12px;
  font-family: TTNormsMedium, sans-serif;
}
.title.id {
  min-width: 120px;
  width: 100%;
  max-width: 150px;
}
.kit-desc.id {
  min-width: 120px;
  width: 100%;
  max-width: 150px;
  cursor: pointer;
  transition: all 0.5s linear;
}
.kit-desc.id:hover {
  color: #005eb8;
  font-family: TTNormsRegular, sans-serif;
}
.title.status {
  min-width: 170px;
  width: 100%;
  max-width: 170px;
}
.kit-desc.status {
  min-width: 170px;
  width: 100%;
  max-width: 170px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.title.first-name {
  min-width: 130px;
  width: 100%;
  max-width: 150px;
}
.kit-desc.first-name {
  min-width: 130px;
  width: 100%;
  max-width: 150px;
}
.title.last-name {
  min-width: 130px;
  width: 100%;
  max-width: 150px;
}
.kit-desc.last-name {
  min-width: 130px;
  width: 100%;
  max-width: 150px;
}
.title.email {
  min-width: 190px;
  width: 100%;
  max-width: 190px;
}
.kit-desc.email {
  min-width: 190px;
  width: 100%;
  max-width: 190px;
  overflow: hidden;
  padding: 0 5px 0 0;
}
.kit-desc.email span {
  width: 100%;
  max-width: 180px;
  overflow: hidden;
  display: inline-block;
}
.kit-desc.first-name span,
.kit-desc.last-name span {
  width: 100%;
  max-width: 140px;
  overflow: hidden;
  display: inline-block;
}
.kit-desc.nodata {
  width: 100%;
  overflow: hidden;
  display: inline-block;
  text-align: center;
}


.title.phone {
  min-width: 150px;
  width: 100%;
  max-width: 150px;
}
.kit-desc.phone {
  min-width: 150px;
  width: 100%;
  max-width: 150px;
}
.title.date {
  margin-left: 0px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  position: relative;
  cursor: pointer;
  gap: 10px;
}
.title.date_list {
  min-width: 160px;
  width: 15%;
  position: relative;
  cursor: pointer;
}
.title.date img {
  max-width: 7px;
  height: 14px;
  margin-top: -2px;
}
.title.date .down {
  transform: rotate(180deg);
}
.kit-desc.date {
  min-width: 160px;
  width: 100%;
}
.kit-desc.date_list {
  min-width: 160px;
  width: 15%;
}
.kits-item {
  display: flex;
  justify-content: space-between;
  position: relative;
  align-items: center;
  padding: 25px 30px;
  background-color: #fff;
  margin: 10px 0;
  border-radius: 5px;
}
.kits-item:hover {
  background-color: #e0e9f4;
}
.kit-desc {
  color: #58595b;
  font-size: 12px;
  font-family: TTNormsLight, sans-serif;
}
.status-line {
  width: 100%;
  max-width: 140px;
  height: 3px;
  background-color: rgba(0, 70, 173, 0.3);
  margin: 5px 0 0 0;
  position: relative;
}
.status-line-bg {
  position: absolute;
  width: 50%;
  content: "";
  left: 0;
  top: 0;
  height: 100%;
  background-color: #005eb8;
}
.pogination {
  margin: 20px 0 0 0;
}
.remove-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
  padding: 0;
}
.onhold-btn {
  background-color: transparent;
  border: none;
  padding: 0;
  max-width: 15px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  margin: 0 0 0 5px;
  cursor: pointer;
}
.onhold-btn-img {
  max-width: 100%;
}
.onHoldStatus {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
@media print {
  .kits {
    display: none;
  }
}
.prob-count {
  text-align: right;
  color: #58595b;
  font-family: TTNormsLight, sans-serif;
  font-size: 15px;
  font-weight: bold;
}
.prob-count.custom {
  margin-bottom: 20px;
}
.link-text {
  color: #58595b;
}
.kits-item:hover .archive-kit-btn {
  display: block;
}
.archive-kit-btn {
  display: none;
  padding-right: 20px;
  cursor: pointer;
}
.archive-kit-btn img{
  width: 20px;
}
.kits-item:hover .remove-kit-btn {
  display: block;
}
.remove-kit-btn {
  display: none;
  position: absolute;
  width: 20px;
  height: 20px;
  border: 1px solid #58595b;
  border-radius: 5px;
  right: 20px;
  cursor: pointer;
  &:before,
  &:after {
    content: "";
    display: block;
    position: absolute;
    height: 1px;
    width: 13px;
    background-color: #58595b;
    top: 50%;
    left: 50%;
    transform: translate(-50%) rotate(45deg);
  }
  &:after {
    transform: translate(-50%) rotate(-45deg);
  }
  &:hover {
    border-color: red;
    &:before,
    &:after {
      background-color: red;
    }
  }
}

.processingoverduelist-color{
     color: #43B02A;
}
.shippedoverdue-color{
     color: #005EB8;
}
.activatedstyle-color{
     color: #F1B434;
}
.awaitingstyle-color{
  color: #AC75BD;
}
.receivedstyle-color{
  color: #00BBDC;
}
.deliveredstyle-color{
  color : #98A4AE;
}
.top-panel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  margin-top: 30px;
}
</style>
